<crm-tgbot-dialog [shouldShowCloseButton]="false" (closeDialog)="onClose(false)">
  <ng-container dialogBody>
    <div class="body">
      @if (data.icon) {
        <mat-icon mboIcon fontSet="material-icons-outlined">{{ data.icon }}</mat-icon>
      }
      <p class="message">
        {{ data.message }}
      </p>
      @if (data.subMessage) {
        <p class="sub-message">
          {{ data.subMessage }}
        </p>
      }
    </div>
  </ng-container>
  <ng-container dialogFooter>
    <div class="actions">
      <button mat-button mboButton (click)="onClose(false)">{{ data.cancelLabel }}</button>
      <button mat-flat-button mboButton (click)="onClose(true)">{{ data.confirmLabel }}</button>
    </div>
  </ng-container>
</crm-tgbot-dialog>
